// extracted by mini-css-extract-plugin
module.exports = {"badge":"Badge_badge__5TJSH","primary":"Badge_primary__QjSnr","secondary":"Badge_secondary__SV9ew","secondaryLight":"Badge_secondaryLight__XHDtG","compact":"Badge_compact__ERB3e"};